import React from 'react';

import { VisuallyHidden } from 'components/ui/visually-hidden';
import { t } from 'state/intl/translations';

/**
 * Opens the link in a new tab.
 */
export const ExternalLink: React.FC<React.PropsWithChildren<React.AnchorHTMLAttributes<{}>>> = ({
  children,
  ...props
}) => {
  return (
    <ExternalLinkView dataSet={undefined} {...props} accessibilityText={t('linkOpensInNewTab')}>
      {children}
    </ExternalLinkView>
  );
};

interface ExternalLinkViewProps extends React.AnchorHTMLAttributes<{}> {
  accessibilityText?: string;
  dataSet: any;
}

export const ExternalLinkView: React.FC<React.PropsWithChildren<ExternalLinkViewProps>> = ({
  children,
  accessibilityText,
  dataSet, // exclude this since it causes issues on web
  ...props
}) => (
  <a {...props} target="_blank" rel="noopener noreferrer">
    {children}
    {!!accessibilityText && <VisuallyHidden accessibilityLabel={accessibilityText} />}
  </a>
);

export default ExternalLink;
